;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.TippingFormGuide = Backbone.Model.extend({
		defaults: {
			data: ''
		},
		url: function() {
			return this.methodUrl;
		},
		loadData: function(match_id) {
			this.methodUrl = 'formguide/'+match_id+'.json';
			return this;

		}
	});

}(window, APP, Backbone, Marionette, $, _));